// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DictionaryTypeDto = {
    AssessmentCompanySize: 'ASSESSMENT_COMPANY_SIZE',
    Certificate: 'CERTIFICATE',
    CertificateCategory: 'CERTIFICATE_CATEGORY',
    Currency: 'CURRENCY',
    Industry: 'INDUSTRY',
    Language: 'LANGUAGE',
    Location: 'LOCATION',
    Offering: 'OFFERING',
    OfferingCategory: 'OFFERING_CATEGORY',
    Skill: 'SKILL',
    SkillCategory: 'SKILL_CATEGORY',
} as const;

export type DictionaryTypeDto = typeof DictionaryTypeDto[keyof typeof DictionaryTypeDto];



